import React from 'react'

import { MedicationRoutes as Routes } from '../../../../../lib/Codes'
import {
  bindTargetMixin,
  CancelButton,
  DateInput,
  SaveButton,
  SelectInput,
  TextInput
} from '../../../../shared/FormBuilder'
import { Paper } from '../../../../shared/NarusMaterial'

const style = {
  saveButton: {
    marginLeft: '1rem'
  }
}

const mapCodeForSelect = options =>
  options.map(o => ({
    ...o,
    label: o.display || o.label,
    value: o.code || o.value
  }))

class SubstanceForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  renderSubstance () {
    const { value } = this.state
    const { onCancel } = this.props
    const disableSave =
      !value.type ||
      !value.start ||
      (value.healthEffects === 'yes' && !value.healthEffectsDetails)

    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Substance Type'
                required
                name='type'
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Substance Amount'
                name='amount'
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                options={mapCodeForSelect(Routes)}
                label='Route'
                name='route'
                hintText='Route'
              />
            </div>
          </div>
          <div className='row middle-xs'>
            <div className='col-xs-12 col-sm-6 mui-date-picker-extended'>
              <DateInput
                label='Start Date'
                name='start'
                required
              />
            </div>
            <div className='col-xs-12 col-sm-6 mui-date-picker-extended'>
              <DateInput
                label='Stop Date'
                name='stop'
              />
            </div>
          </div>

          <div
            className='row end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }

  render () {
    return <div>{this.renderSubstance()}</div>
  }
}

export default SubstanceForm
